export const SearchConfigs = {
    hideSorting: true,
    filterData: {
        filtersTitle: '',
        filtersDisplayType: '',
        generalKeys: [],
        filterSets: []
    }
};
